import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Collapse,
  Flex,
  HStack,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";
// import { IoIosArrowRoundBack } from "react-icons/io";
import { MdClear } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { SelectFieldV2 } from "../../components/selectField/SelectFieldV2";
import { PrecisionCategoriesOptionsType } from "../../graphql/generated";
import { TierFilter } from ".";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../../lib/cache";
import { PublisherEnum, RangeEnum } from "../../graphqlExternal/generated";
import {
  formatTextDisplay,
  getDateRangeLabel,
} from "../../utils/displayGetters";
import { DownloadCorrectionsButton } from "./urlList/downloadCorrectionsButton";
import { DateRangeSelector } from "../../components/dateRangeSelector/DateRangeSelector";

export enum ReviewTypeEnum {
  All = "ALL",
  Corrections = "CORRECTIONS",
  // Predictions = "PREDICTIONS",
}

interface HeaderProps {
  precisionCategories: PrecisionCategoriesOptionsType[];
  urlSearch: string;
  setUrlSearch: React.Dispatch<React.SetStateAction<string>>;
  categoryFilter: { label: string; value: string };
  setCategoryFilter: React.Dispatch<
    React.SetStateAction<{ label: string; value: string }>
  >;
  correctionsFilter: { label: string; value: string };
  setCorrectionsFilter: React.Dispatch<
    React.SetStateAction<{ label: string; value: string }>
  >;
  publisherFilter: { label: string; value: string };
  setPublisherFilter: React.Dispatch<
    React.SetStateAction<{ label: string; value: string }>
  >;
  dateRangeFilter: { label: string; value: string };
  setDateRangeFilter: React.Dispatch<
    React.SetStateAction<{ label: string; value: string }>
  >;
  startDateFilter: null | string;
  setStartDateFilter: React.Dispatch<React.SetStateAction<null | string>>;
  endDateFilter: null | string;
  setEndDateFilter: React.Dispatch<React.SetStateAction<null | string>>;
}

export const Header = ({
  precisionCategories,
  urlSearch,
  setUrlSearch,
  categoryFilter,
  setCategoryFilter,
  correctionsFilter,
  setCorrectionsFilter,
  publisherFilter,
  setPublisherFilter,
  dateRangeFilter,
  setDateRangeFilter,
  startDateFilter,
  setStartDateFilter,
  endDateFilter,
  setEndDateFilter,
}: HeaderProps) => {
  const currentUser = useReactiveVar(userDetailsVar);
  const [localUrlSearch, setLocalUrlSearch] = useState("");
  const [localCategoryFilter, setLocalCategoryFilter] = useState({
    label: "All Categories",
    value: "ALL",
  });
  const [localCorrectionsFilter, setLocalCorrectionsFilter] = useState({
    label: "All",
    value: "ALL",
  });

  const [localStartDateFilter, setLocalStartDateFilter] =
    useState(startDateFilter);
  const [localEndDateFilter, setLocalEndDateFilter] = useState(endDateFilter);
  const [localDateRangeFilter, setLocalDateRangeFilter] =
    useState(dateRangeFilter);
  const [localPublisherFilter, setLocalPublisherFilter] =
    useState(publisherFilter);
  const [showCustomDate, setShowCustomDate] = useState(false);

  const navigate = useNavigate();
  // const location = useLocation();
  // const position = location.state

  const publisherFilterOptions: {
    label: string;
    value: PublisherEnum;
  }[] = [
    ...Object.entries(PublisherEnum).map(([, value]) => ({
      label: formatTextDisplay(value),
      value: value,
    })),
  ];

  const dateRangeFilterOptions: {
    label: string;
    value: RangeEnum;
  }[] = [
    ...Object.entries(RangeEnum).map(([, value]) => ({
      label: getDateRangeLabel(value),
      value: value,
    })),
  ];

  const correctionCategories: { label: string; value: ReviewTypeEnum }[] = [
    ...Object.entries(ReviewTypeEnum).map(([, value]) => ({
      label: formatTextDisplay(value),
      value: value,
    })),
    // { label: "All", value: "ALL" },
    // { label: "Corrections", value: "CORRECTIONS" },
    // { label: "Predictions", value: "PREDICTIONS" },
  ];

  // Currently the predictions option will only be available to staff
  // if (!currentUser?.isStaff) {
  //   const predictionIndex = correctionCategories.findIndex(
  //     (item) => item.value === ReviewTypeEnum.Predictions
  //   );
  //   if (predictionIndex !== -1) {
  //     correctionCategories.splice(predictionIndex, 1);
  //   }
  // }

  // Limit to 3 tiers and add ALL option
  const tieredCategories = TierFilter(precisionCategories, 3);
  tieredCategories.unshift({ label: "All Categories", value: "ALL" });

  // const atUrlList = window.location.pathname.includes("/human-in-the-loop/url-list");

  // function handleRedirect() {
  //   if (atUrlList) {
  //     navigate("./");
  //   } else {
  //     navigate("./url-list"); // {state: position }

  //   }
  // }

  const assignFilters = () => {
    setUrlSearch(localUrlSearch);
    setCategoryFilter(localCategoryFilter);
    setCorrectionsFilter(localCorrectionsFilter);
    setPublisherFilter(localPublisherFilter);
    setDateRangeFilter(localDateRangeFilter);
    setStartDateFilter(localStartDateFilter);
    setEndDateFilter(localEndDateFilter);
    navigate("./url-list");
  };

  const currentDate = new Date();
  const filterStartDate = new Date(currentDate);
  filterStartDate.setDate(currentDate.getDate() - 183);
  const filterEndDate = new Date(currentDate);

  const onStartDateFilterChange = (value: string) => {
    const startDate = new Date(value);
    setLocalStartDateFilter(startDate.toISOString().split("T")[0]);
  };

  const onEndDateFilterChange = (value: string) => {
    const endDate = new Date(value);
    setLocalEndDateFilter(endDate.toISOString().split("T")[0]);
  };

  return (
    <Box>
      <Box
        // backgroundColor={"white"}
        // py={10}
        // px={6}
        mb={4}
        mx={"auto"}
        // borderRadius={"lg"}
        width={"100%"}
      >
        <HStack
        // spacing={1}
        // align={"center"}
        >
          {/* <Box as={"button"} onClick={() => handleRedirect()}>
            <HStack
              _hover={{
                stroke: "primary.darker",
                color: "primary.darker",
              }}
            >
              <Icon
                as={IoIosArrowRoundBack}
                width={6}
                height={6}
                strokeWidth={10}
              />
              <Text fontSize={"sm"}>
                {atUrlList ? `Back` : `Back to URL's list`}
              </Text>
            </HStack>
          </Box> */}
        </HStack>
      </Box>
      <Box width={"100%"} mx={"auto"} mb={2}>
        <Flex
          justifyContent={[null, null, "space-between", null, null]}
          flexDirection={"column"} //{["column", null, null, null, "column"]}
          gridGap={2} //{[1, null, 2, null, null]}
        >
          <Flex flexDirection={"row"} gridGap={2}>
            <Tooltip
              label={"Search term must contain at least 3 letters"}
              openDelay={600}
              p={2}
            >
              <InputGroup>
                <InputLeftElement pointerEvents={"none"}>
                  <Icon
                    as={FiSearch}
                    w={[3, null, null, 4, null]}
                    h={[3, null, null, 4, null]}
                  />
                </InputLeftElement>
                <Input
                  variant="greyInput"
                  placeholder={"Search URL"}
                  value={localUrlSearch}
                  onChange={(e) => {
                    setLocalUrlSearch(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      assignFilters();
                      (e.target as HTMLInputElement).blur();
                    }
                  }}
                />
                <InputRightElement>
                  <Collapse in={!!urlSearch}>
                    <IconButton
                      aria-label={"clear-search-query"}
                      variant={"unstyled"}
                      pl={2}
                      onClick={() => {
                        setLocalUrlSearch("");
                      }}
                      icon={
                        <Icon
                          as={MdClear}
                          w={[3, null, null, 4, null]}
                          h={[3, null, null, 4, null]}
                        />
                      }
                    />
                  </Collapse>
                </InputRightElement>
              </InputGroup>
            </Tooltip>
            {correctionsFilter.value === ReviewTypeEnum.Corrections && (
              <DownloadCorrectionsButton
                urlSearch={urlSearch}
                dateRangeFilter={dateRangeFilter}
                categoryFilter={categoryFilter}
                startDateFilter={filterStartDate}
                endDateFilter={filterEndDate}
              />
            )}
          </Flex>
          <Flex
            align="start"
            flexDirection={["column", null, null, "row", null]}
            gridGap={[2, null, null, "1%", null]}
            width={"100%"}
          >
            <VStack align="start" width={"100%"}>
              <Flex
                // justifyContent={[null, null, "space-between", null, null]}
                flexDirection={["column-reverse", null, null, "row", null]}
                gridGap={[2, null, null, "1%", null]}
                width={"100%"}
                justifyContent={"flex-end"}
              >
                {(localCorrectionsFilter.value === ReviewTypeEnum.All ||
                  localCorrectionsFilter.value ===
                    ReviewTypeEnum.Corrections) && (
                  <Box w={[null, null, "100%", "33%", null]}>
                    <SelectFieldV2
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          backgroundColor: "white",
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          backgroundColor: "white",
                          borderColor: "chakra.colors.theme.blueInputHover",
                          // width: "100%",
                          borderRadius: "3px",
                        }),
                        menu: (base) => ({
                          ...base,
                          borderColor: "chakra.colors.theme.blueInputHover",
                          borderwidth: "2px",
                          borderRadius: "chakraTheme.radii.xs",
                        }),
                      }}
                      placeholder={`Select Range`}
                      onChange={(option) => {
                        setLocalDateRangeFilter(option);
                        if (option.value !== "CUSTOM") {
                          setShowCustomDate(false);
                        } else {
                          setShowCustomDate(true);
                        }
                      }}
                      isMulti={false}
                      options={dateRangeFilterOptions}
                      value={localDateRangeFilter}
                    />
                  </Box>
                )}

                {currentUser?.isStaff && (
                  <Box w={[null, null, "100%", "33%", null]}>
                    <SelectFieldV2
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          backgroundColor: "white",
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          backgroundColor: "white",
                        }),
                        menu: (base) => ({
                          ...base,
                          borderColor: "chakra.colors.theme.blueInputHover",
                          borderwidth: "2px",
                          borderRadius: "chakraTheme.radii.xs",
                        }),
                      }}
                      placeholder={"Select Publisher"}
                      isMulti={false}
                      value={localPublisherFilter}
                      options={publisherFilterOptions}
                      onChange={(option) => {
                        setLocalPublisherFilter(option);
                      }}
                    />
                  </Box>
                )}

                <Box w={[null, null, "100%", "33%", null]}>
                  <SelectFieldV2
                    styles={{
                      valueContainer: (base) => ({
                        ...base,
                        backgroundColor: "white",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        backgroundColor: "white",
                      }),
                      menu: (base) => ({
                        ...base,
                        borderColor: "chakra.colors.theme.greyInput",
                        borderRadius: "chakraTheme.radii.xs",
                      }),
                    }}
                    placeholder={`Select category`}
                    onChange={(option) => {
                      setLocalCategoryFilter(option);
                    }}
                    isMulti={false}
                    options={tieredCategories}
                    value={
                      localCategoryFilter.value ? localCategoryFilter : null
                    }
                  />
                </Box>

                <Box w={[null, null, "100%", "33%", null]}>
                  <SelectFieldV2
                    styles={{
                      valueContainer: (base) => ({
                        ...base,
                        backgroundColor: "white",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        backgroundColor: "white",
                      }),
                      menu: (base) => ({
                        ...base,
                        borderColor: "chakra.colors.theme.blueInputHover",
                        borderRadius: "chakraTheme.radii.xs",
                      }),
                    }}
                    placeholder={`Select Correction Type`}
                    isMulti={false}
                    value={localCorrectionsFilter}
                    options={correctionCategories}
                    onChange={(option) => {
                      setLocalCorrectionsFilter(option);
                    }}
                  />
                </Box>
              </Flex>
              {showCustomDate && (
                <Box w={[null, null, "100%", "33%", null]}>
                  <DateRangeSelector
                    startDate={filterStartDate}
                    endDate={filterEndDate}
                    onStartDateChange={onStartDateFilterChange}
                    onEndDateChange={onEndDateFilterChange}
                    inputVariant="greyInput"
                    openDate={currentDate}
                  />
                </Box>
              )}
            </VStack>
            <Button
              // Filter is only active when the search or category or corrections filter has been changed.
              // Search term must be more than 4 letters.
              // Custom dates require date selection for filter to be active
              isDisabled={
                ((localUrlSearch === urlSearch ||
                  (localUrlSearch.length > 0 && localUrlSearch.length < 3)) &&
                  localCategoryFilter.value === categoryFilter.value &&
                  localCorrectionsFilter.value === correctionsFilter.value &&
                  localPublisherFilter.value === publisherFilter.value &&
                  localDateRangeFilter.value !== RangeEnum.Custom &&
                  localDateRangeFilter.value === dateRangeFilter.value) ||
                (localDateRangeFilter.value === RangeEnum.Custom &&
                  (localStartDateFilter === startDateFilter ||
                    localEndDateFilter === endDateFilter ||
                    localStartDateFilter === null ||
                    localEndDateFilter === null) &&
                  localCategoryFilter.value === categoryFilter.value &&
                  localCorrectionsFilter.value === correctionsFilter.value &&
                  localPublisherFilter.value === publisherFilter.value &&
                  (localUrlSearch === urlSearch ||
                    (localUrlSearch.length > 0 && localUrlSearch.length < 3)))
              }
              // && localCorrectionsFilter.value === localCategoryFilter
              variant={"blueButton"}
              w={[null, null, "100%", "10%", null]}
              _hover={{
                opacity: 0.3,
              }}
              onClick={() => {
                assignFilters();
              }}
            >
              Filter
            </Button>
          </Flex>
        </Flex>
      </Box>
      <Collapse
        in={urlSearch && dateRangeFilter.value !== "ALL" ? true : false}
      >
        <Alert status={"info"} backgroundColor={"primary.light"} mb={2}>
          <AlertIcon color={"primary.dark"} />
          Note: To search the full collection of urls change the date range to
          &quot;All&quot;.
        </Alert>
      </Collapse>
    </Box>
  );
};
